import React from 'react';
export const Header = () => {
  return <header className="bg-blue-700 text-white p-3 sticky top-0 z-50 shadow-md" data-id="element-44">
      <div className="max-w-4xl mx-auto flex justify-between items-center" data-id="element-45">
        <div className="font-bold text-base md:text-lg" data-id="element-46">HEALTH NEWS</div>
        <div className="text-sm md:text-base" data-id="element-47">UPDATED TODAY</div>
      </div>
    </header>;
};